/**
 * Sign in scene
 * 
 * @author Mautilus s.r.o.
 * @class Scene_SignIn
 * @extends Scene
 */

Scene_SignIn = (function(Scene) {

	var Scene_SignIn = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_SignIn.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function(){
			console.log('[Scene] init ' + this.name + ' scene');

			this.dontRedraw = false; // prevent to redraw scene

			this.snippetSignIn = new Snippet_SignIn(this, {});
		},
		
		/**
		 * @inheritdoc Scene#create
		 */
		create: function() {
			return $('#scene-signin');
		},
		
		/**
		 * @inheritdoc Scene#activate
		 */
		activate: function() {
			console.log('[Activate] ' + this.name);
			// if ( Device.isWEBOS ) {
			// 	Device.clearHistory();
			//   Device.pushHistory();
			// }

			return Promise.resolve();
		},
		
		/**
		 * @inheritdoc Scene#render
		 */
		render: function() {
			this.$el.find('.main-title').text(__('please_sign_in'));
			this.$el.find('.issueLogin').text(__('issue_login'));
			this.snippetSignIn.render();
		},

		/**
		 * @inheritdoc Scene#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Scene#onEnter
		 */
		onEnter: function($el, event) {
		},
		/**
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function($el, event) {
			if (Device.isWEBOS) {
				Device.openWebOSSmartHub();	// on webos we dont show exit dialog, we open the smart menu
			} else if (!App.dialog) {
				var exitDialog = new Snippet_Dialog_exit(null, {
					'selector': 'dialog-exit'
				});
				exitDialog.render();
			} else {
				App.dialog.onClose();
			}
			return false;
		},
		/**
		 * @inheritdoc Scene#navigate
		 */
		navigate: function(direction) {
		},
		
		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function() {
			// Focus.to(this);
		},
		
		/**
		 * @inheritdoc Scene#onBeforeGoBack
		 */
		onBeforeGoBack: function(fromScene) {
			this.dontRedraw = true;
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Scene
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}

	});

	return Scene_SignIn;

})(Scene);


//////////////////
// WEBPACK FOOTER
// ./js/scene/signin.js
// module id = 57
// module chunks = 0